export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
			title: "BERJAYA FINANCE",
			iconOnly: false,
			collapsible: true
		}
	},
};